(function () {
  class ShopifyLottie {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.player = wrapper.querySelector('lottie-player');
      if (!this.player) return;

      this.init();
    }

    init() {
      const d = this.wrapper.dataset;

      this.player.loop = d.loop === 'true';
      this.player.autoplay = d.autoplay === 'true';
      this.player.speed = parseFloat(d.speed) || 1;
      this.player.direction = parseInt(d.direction, 10) || 1;
      this.player.mode = d.mode || 'normal';
    }
  }

  /* Init all lottie sections */
  function initLottieSections(root = document) {
    root.querySelectorAll('[data-lottie]').forEach(wrapper => {
      if (!wrapper.__lottieInit) {
        wrapper.__lottieInit = true;
        new ShopifyLottie(wrapper);
      }
    });
  }

  /* Initial load */
  document.addEventListener('DOMContentLoaded', () => {
    initLottieSections();
  });

  /* Shopify theme editor + AJAX support */
  document.addEventListener('shopify:section:load', (event) => {
    initLottieSections(event.target);
  });
})();